import PropTypes from 'prop-types';
import React from 'react';

const InlineOverlayBody = ({ children, className = '' }) => (
  <div className={`content-body ${className}`}>{children}</div>
);

InlineOverlayBody.displayName = 'InlineOverlayBody';
InlineOverlayBody.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string
};

export default InlineOverlayBody;
